// en, de, fr, pt
export default {
	th: {
		Orderers: '79.ผู้จ้าง',
		Cutdirections: '78.ทิศทางตัด',
		Slabstypes: '77.ประเภทแผ่นหิน',
		Gangsaws: '76.เครื่องตัด',
		RRLB: '9.ซื้อเงินเชื่อTHC(ค่าแรงช่าว)LB',
		RRRY: '8.ซื้อเงินเชื่อTHC(สาขาลำลูกกา)RY',
		RRRW: '7.ซื้อเงินเชื่อTHC(โรงงาน)RW',
		RRIM: '5.ใบสั่งซื้อ(Import)IM',
		RR1R: '3.ให้กู้ยืมเงิน1R',
		POPG: '6.ใบจ้างทำTHC(ลำลูกกา)PG',
		POML: '5.ใบสั่งซื้อ(Import)ML',
		POFM: '1.ใบสั่งซื้อ(โรงงาน)FM',
		"POPO-SLAB": '7.ใบสั่งซื้อ(โรงงาน)FM(SLAB)',
		"QUQT-BLOCK": '1.ใบเสนอราคา(โรงงาน)QT (Material)',
		"QUQB-BLOCK": '2.ใบเสนอราคา(BANGKOK)QB (Payment)',
		"QUQS-BLOCK": '5.ใบเสนอราคาTHC(สาขาลำลูกกา)QS (Labour)',
		"QUQO-BLOCK": '6.ใบเสนอราคา(THCM + THC)QO',
		"QUQL-BLOCK": '3.ใบเสนอราคา(ลำลูกกา)QL (Material) ',
		"QUQF-BLOCK": '4.ใบเสนอราคาTHC(โรงงาน)QF (Labour)',
		POPB: '2.ใบสั่งซื้อ(สาขาBangkok)PB',
		POPF: '4.ใบจ้างทำTHC(โรงงาน)PF',
		POPU: '3.ใบสั่งซื้อ(สาขาลำลูกกา)PU',
		RRFM: '1.ซื้อเงินเชื่อ(โรงงาน)FM',
		RRPB: '2.ซื้อเงินเชื่อ(สาขาBangkok)PB',
		RRPF: '4.ใบจ้างทำเงินเชื่อTHC(โรงงาน)PF',
		RRPU: '3.ซื้อเงินเชื่อ(สาขาลำลูกกา)PU',
		Currencys: '73.สกุลเงิน',
		Locations2: '72.สถานที่',
		Projects: '71.โครงการ',
		ProductsGrade: '23.ระดับสินค้า',
		ChartOfAccount: 'ผังบัญชี',
		Selected: 'เลือก',
		Notfound: 'ไม่พบรายการ',
		Inputs: 'เติม',
		Prints: 'ปริ้นท์',
		Grids: 'ตาราง',
		Fields: 'Field',
		Titles: 'หัวข้อ',
		columns: 'คอลัมน์',
		payments_types: 'เงื่อนไขการชำระเงิน',
		ReceiveDate: 'รับของ',
		Qtyunits: '20.หน่วยสินค้า',
		Titlepos: 'คำนำหน้าชื่อ',
		Costs: 'ต้นทุน',
		Returns: 'คืน',
		Cumulative: 'สะสม',
		Debits: 'เดบิต',
		Credits: "เครดิต",
		Depreciation: 'ค่าเสื่อม',
		Assets: 'ทรัพย์สิน',
		Cheque: 'เช็ค',
		Deadline: 'วันเกินกำหนด',
		Duedate: 'วันครบกำหนด',
		Remarks: 'หมายเหตุ',
		Changed: 'เปลี่ยน',
		Banks: 'ธนาคาร',
		Formats: 'รูปแบบ',
		Decimals: 'ทศนิยม',
		Multiplys: 'คูณ',
		Periods: 'ช่วง',
		Show: 'แสดง',
		Hide: 'ซ่อน',
		Save: 'บันทึก',
		Phone: 'โทรศัพท์',
		English: 'อังกฤษ',
		Chinese: 'จีน',
		Company: "บริษัท",
		Thai: 'ไทย',
		CompanysTypes: 'ประเภทกิจการ',
		SettingStarts: '1.กำหนดค่าเริ่มต้นต่างๆ',
		SettingTables: '2.กำหนดตารางข้อมูล',
		SettingFinrounds: '3.กำหนดรอบบัญชี',
		SettingDocuments: '4.กำหนดเลขที่เอกสาร',
		SettingFincons: '5.กำหนดการเชื่อมต่อบัญชี',
		SettingDepts: '6.กำหนดแผนก',
		SettingNewcoms: '7.กำหนดบริษัทใหม่',
		SettingMessages: '8.รายการข้อความ',
		SettingForms: 'B.กำหนดแบบฟอร์ม',
		SettingFormsBuy: '1.กำหนดแบบฟอร์มซื้อ',
		SettingFormsSell: '2.กำหนดแบบฟอร์มขาย',
		SettingMessagesGeneral: '1.ทั่วไป',
		SettingMessagesVendor: '2.เจ้าหนี้',
		SettingMessagesCustomer: '3.ลูกค้า',
		SettingMessagesBank: '4.ธนาคาร',
		SettingMessagesVat: '5.ภาษี',
		SettingMessagesProduct: '6.สินค้า',
		SettingMessagesFinance: '7.บัญชี',
		SettingStartsCompany: '1.รายละเอียดกิจการ',
		SettingStartsGeneral: '2.เรื่องทั่วไป',
		SettingStartsStockRemains: '3.ระบบสินค้าคงเหลือ',
		SettingStockRemains: '2.กลุ่มบัญชีสินค้า',
		SettingStartsSellandCustomer: '4.ระบบขายและลูกหนี้',
		SettingStartVendorMethod: '2.วิธีการชำระหนี้',
		SettingStartsBuyandSuppliers: '5.ระบบซื้อและเจ้าหนี้',
		SettingStartsBanks: '6.ระบบการเงินและการธนาคาร',
		SettingStartsFin: '7.ระบบบัญชี',
		SettingStartsAssets: '8.ระบบทรัพย์สิน',
		SettingAssets: '2.กลุ่มบัญชีทรัพย์สิน',
		GeneralsDetails: '1.รายละเอียดทั่วไป',
		Productday: '1. รายการประจำวันสินค้า',
		ProductTransfer: '3.โอนย้ายระหว่างคลัง',
		ProductAdj: '4.ปรับปรุงยอดสินค้า',
		ProductCost: '5.ปรับปรุงต้นทุนสินค้า',
		Account: 'บัญชี',
		SettingStartsBanksDetail: 'รายละเอียดธนาคาร',
		SettingStartsBanksName: '01.ชื่อธนาคาร',
		Values: 'ค่า',
		WHT: 'หัก ณ ที่จ่าย',
		percent: 'เปอร์เซ็นต์',
		Vats: 'ภาษีมูลค่าเพิ่ม',
		Ports: 'ท่าเรือ',
		Countrys: 'ประเทศ',
		Terms: 'เทอม',
		Agents: 'ตัวแทน',
		Modes: 'หมวด',
		Modessub: 'หมวดย่อย',
		Modessubmore: 'หมวดย่อยเสริม',
		Choose: 'เลือก',
		Supplier: 'ผู้จำหน่าย',
		Salesman: 'พนักงานขาย',
		SupplierDetails: '6.รายละเอียดผู้จำหน่าย',
		Customers: 'ผู้ซื้อ',
		CustomerDetails: 'รายละเอียดลูกค้า',
		Cash: 'เงินสด',
		Credit: 'เงินเชื่อ',
		Price: 'ราคา',
		Details: 'รายละเอียด',
		Header: 'หัว',
		Footer: 'รายการ',
		Buy: '1.ซื้อ',
		Sell: '2.ขาย',
		SellOrder: '3.ใบสั่งขาย',
		sellorder: '2.ใบสั่งขาย',
		SellOrder2: 'ใบสั่งขาย',
		SellCredits: '4.ขายเงินเชื่อ',
		Quotations: 'A.ใบเสนอราคา',
		Quotationm: '3.ใบเสนอราคา',
		Quotations1: '1.ใบเสนอราคา',
		Quotations2: '2.ใบเสนอราคาประมูล',
		Day: 'วัน',
		Month: 'เดือน',
		Year: 'ปี',
		Balance: 'สมดุล',
		Decrease: 'ลด',
		Increase: 'เพิ่ม',
		poreport: '3.ใบสั่งซื้อ',
		poreport1: '1.เรียงตามเลขที่',
		poreport2: '2.เรียงตามวันที่',
		poreport3: '3.แยกตามผู้จำหน่าย',
		poreport4: '4.สินค้าค้างรับ แยกตามสินค้า',
		poreport5: '5.สินค้าค้างรับ แยกตามใบสั่งซื้อ',
		poreport6: '6.สินค้าค้างรับ แยกตามผู้จำหน่าย',
		poreport7: '7.สินค้าถูกยกเลิก แยกตามสินค้า',
		poreport8: '8.สินค้าถูกยกเลิก แยกตามใบสั่งซื้อ',
		poreport9: '9.สินค้าถูกยกเลิก แยกตามผู้จำหน่าย',
		poreportA: 'A.สินค้าถูกยกเลิก แยกตามเหตุผล',
		customersreport: '1.รายงานลูกหนี้',
		vendorsreport: '2.รายงานเจ้าหนี้',
		chequereport: '3.รายงานเกี่ยวกับเช็ค',
		inventorysreport: '4.รายงานสินค้าคงคลัง',
		financesreport: '5.รายละเอียดบัญชี',
		taxsreport: '6.รายละเอียดภาษี',
		buystatisticsreport: '7.รายงานวิเคราะห์การขาย',
		sellstatisticsreport: '8.รายงานวิเคราะห์การซื้อ',
		customizereport: '9.สร้างรายงานด้วยตัวเอง',
		Slabsfinalstransreport: 'B.สรุปยอดเคลื่อนไหวสินค้า',
		SlabsfinalstransreportBlocks: 'สรุปยอดเคลื่อนไหวสินค้า-BLOCK',
		SlabsfinalstransreportSlabs: 'สรุปยอดเคลื่อนไหวสินค้า-SLAB',
		Slabstransreport: 'รายงานความเคลื่อนไหวหินแผ่น',
		Blockstransreport: 'รายงานความเคลื่อนไหวบล็อค',
		ProductsTransreport: 'รายงานความเคลื่อนไหวผลผลิต',
		Report: '6.รายงาน',
		BlocksCut: '1.ตัดแบ่งบล็อค (Gangsaw)',
		SlabsCut: '2.ตัดแบ่งแผ่นหิน (Bridge Cutting)',
		Address: 'ที่อยู่',
		PO_Block: 'คำสั่ง Block',
		PO_Slab: 'คำสั่ง Slab',
		Locations: '21.คลัง',
		Block: 'ซื้อบล็อค',
		BlockG: 'บันทึก (Gangsaw Finishing)',
		Slab: 'ซื้อสแลป',
		SlabPO: 'แผ่นหินตาม PO ผลผลิต',
		Standards: 'มาตรฐาน',
		Generals: 'ทั่วไป',
		Contacts: 'ติดต่อ',
		FinishedGoods: 'สินค้าสำเร็จ',
		Cuttings: 'ตัดแบ่ง',
		RawMaterial: 'วัตถุดิบ',
		Products: 'สินค้า',
		FinancesDetails: '3.การเงิน',
		ProductsDetails: '4.รายละเอียดสินค้า',
		AccountsDetails: '5.บัญชี',
		Productstrans:'A.รายงานเคลื่อนไหวสินค้า',
		ProductsDaily: '1.รายการประจำวันสินค้า',
		ProductsInside: '1.จ่ายสินค้าภายใน',
		ProductsTransfer: '2.โอนย้ายระหว่างคลัง',
		ProductsAdjust: '3.ปรับปรุงยอดสินค้า',
		ProductsAdjustCost: '4.ปรับปรุงต้นทุนสินค้า',
		ProductsNormal: '2.รายละเอียดสินค้า(มีสต็อค)',
		ProductsService: '3.รายละเอียดสินค้าบริการ(ไม่มีสต็อค)',
		ProductType: '02.หมวดสินค้า',
		WhtMode: '55.หมวดภาษีหัก ณ ที่จ่าย',
		Transmode: '41.ขนส่งโดย',
		Paymenttypes: '70.เงื่อนไขการชำระเงิน',
		Vtypes: '74.ประเภทราคา',
		Custypes: '75.ประเภทลูกค้า',
		Buyfroms: '80.สถานที่ซื้อ',
		BlockReport: 'รายงานสินค้าและวัตถุดิบ',
		List: 'รายการ',
		Purchase: 'ซื้อ',
		Deposit: '1.จ่ายมัดจำ',
		deposit: '1.จ่ายมัดจำ',
		PurchaseOrderNumber: 'เลขที่ใบสั่งซื้อ',
		PurchaseOrder: '3.ใบสั่งซื้อ',
		purchaseorder: '2.ใบสั่งซื้อ',
		PurchaseCredit: '4.ซื้อเงินเชื่อ',
		purchasecredit: '3.ซื้อเงินเชื่อ',
		PurchaseAndOrder: 'คำสั่งซื้อ/คำสั่ง',
		Order: '4.คำสั่ง',
		Vendors: 'เจ้าหนี้',
		Setting: '7.เริ่มระบบ',
		Othersmenu: '8.อื่นๆ',
		GetMoney: '1.รับเงิน',
		PayMoney: '2.จ่ายเงิน',
		PayBill: '1.ใบรับวางบิล',
		DebitInvoice: '2.ใบเพิ่มหนี้',
		CreditInvoice: '3.ใบลดหนี้/ส่งคืนสินค้า',
		Payments: '4.จ่ายชำระหนี้',
		VendorsOutstanding: '5.บันทึกรายการเจ้าหนี้คงค้าง-ยกมา',
		MyHome: 'หน้าหลัก',
		Dashboard: 'กระดาน',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		FullCalendar: 'Full Calendar',
		SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		ItemDetails: 'Item Details',
		Cart: 'Cart',
		WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		CardColors: 'Card Colors',
		Table: 'Table',
		agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		User: 'User',
		View: 'View',
		Edit: 'Edit',
		UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'ค้นหา',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
		DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
		StarRatings: 'Star Ratings',
		Autocomplete: 'Autocomplete',
		Tree: 'Tree',
		// "Import/Export": 'Import/Export',
		Import: 'Import',
		Export: 'Export',
		ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	cn: {
		Currencys: '73.貨幣',
		Locations2: '72.位置',
		Projects: '71.項目',
		ProductsGrade: '23.產品等級',
		ChartOfAccount: '會計科目表',
		Selected: '選擇',
		Notfound: '未找到',
		Inputs: '輸入',
		Prints: '打印',
		Grids: 'Grid',
		Fields: 'Field',
		Titles: '標題',
		columns: '柱',
		payments_types: '支付方式',
		ReceiveDate: '收到日期',
		SettingForms: 'B.表格設定',
		SettingFormsBuy: '1.購買表格設置',
		SettingFormsSell: '2.出售表格設置',
		Qtyunits: '20.數量單位',
		Paymenttypes: '70.支付方式',
		Transmode: '41.運輸',
		WhtMode: '55.持有稅',
		Deposit: '1.存款',
		deposit: '1.存款',
		Titlepos: '名稱前綴',
		Costs: '成本',
		Returns: '返回',
		Cumulative: '累積的',
		Debits: '借方',
		Credits: "信用",
		Depreciation: '折舊',
		Assets: '資產',
		Cheque: '校驗',
		Deadline: '最後期限',
		Duedate: '截止日期',
		Remarks: '備註',
		Generals: '一般',
		Changed: '更改',
		Banks: '銀行',
		Formats: '格式',
		Decimals: '小數',
		Multiplys: '乘',
		Periods: '期',
		Show: '顯示',
		Hide: '隱藏',
		Save: '救',
		Phone: '電話',
		English: '英語',
		Chinese: '中文',
		Thai: '泰國',
		Company: "公司",
		CompanysTypes: '公司類型',
		SettingStarts: '1.設置開始',
		SettingTables: '2.設置數據庫',
		SettingFinrounds: '3.設置融資回合',
		SettingDocuments: '4.設置文件',
		SettingFincons: '5.設置財務連接',
		SettingDepts: '6.設置部門',
		SettingNewcoms: '7.成立新公司',
		SettingMessages: '8.設定訊息',
		SettingMessagesGeneral: '1.一般',
		SettingMessagesVendor: '2.供應商',
		SettingMessagesCustomer: '3.顧客',
		SettingMessagesBank: '4.銀行',
		SettingMessagesVat: '5.增值稅',
		SettingMessagesProduct: '6.產品',
		SettingMessagesFinance: '7.金融',
		SettingStartsCompany: '1.公司資料',
		SettingStartsGeneral: '2.一般',
		SettingStartsStockRemains: '3.剩餘庫存',
		SettingStockRemains: '2.產品組',
		SettingStartsSellandCustomer: '4.銷售和客戶',
		SettingStartVendorMethod: '2.付款方法',
		SettingStartsBuyandSuppliers: '5.買和賣',
		SettingStartsBanks: '6.金錢和銀行',
		SettingStartsFin: '7.金融',
		SettingStartsAssets: '8.資產',
		SettingAssets: '2.組資產',
		GeneralsDetails: '1.一般',
		SettingStartsBanksDetail: '銀行明細',
		SettingStartsBanksName: '銀行名',
		Account: '帳戶',
		Values: '價值觀',
		WHT: '預扣稅',
		percent: '百分',
		Vats: '增值稅',
		Ports: '港口',
		Countrys: '國家',
		Terms: '術語',
		Agents: '代理人',
		Modes: '模式',
		Modessub: '子模式',
		Modessubmore: '子模式 更多',
		Choose: '選擇',
		Customers: '顧客',
		CustomerDetails: '客戶詳情',
		Supplier: '供應商',
		SupplierDetails: '供應商',
		Cash: '現金',
		Credit: '信用',
		Price: '價錢',
		Details: '詳情',
		Buy: '購買',
		Sell: '賣',
		SellOrder: '3.賣單',
		sellorder: '2.賣單',
		SellOrder2: '賣單',
		SellCredits: '出售信貸',
		Day: '天',
		Month: '月',
		Year: '年',
		Balance: '平衡',
		Decrease: '減少',
		Increase: '增加',
		Slabsfinalstransreport: '平板 橫切 完成',
		Slabstransreport: '平板 橫切',
		Blockstransreport: '塊 橫切',
		Report: '報告',
		BlocksCut: '切割 塊',
		SlabsCut: '切割 平板',
		Address: '地址',
		PO_Block: '訂購 Block',
		PO_Slab: '訂購 Slab',
		Locations: '位置',
		Block: '塊',
		Slab: '平板',
		Contacts: '聯繫',
		FinishedGoods: '完成品',
		Cuttings: '切割',
		RawMaterial: '原材料',
		Products: '產品',
		ProductsDetails: '產品信息',
		ProductsNormal: '2.產品信息(Stock)',
		ProductsService: '3.產品信息(No Stock)',
		ProductType: '產品類別',
		List: '清單',
		Purchase: '採購',
		PurchaseOrderNumber: '訂購單號碼',
		PurchaseOrder: '3.採購訂單',
		purchaseorder: '2.採購訂單',
		PurchaseCredit: '4.採購 信用',
		purchasecredit: '3.採購 信用',
		PurchaseAndOrder: '採購訂單/訂購',
		Order: '訂購',
		Vendors: '供应商',
		Setting: '设置',
		MyHome: '家',
		Dashboard: '仪表板',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		FullCalendar: 'Full Calendar',
		SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		ItemDetails: 'Item Details',
		Cart: 'Cart',
		WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		CardColors: 'Card Colors',
		Table: 'Table',
		agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		User: 'User',
		View: 'View',
		Edit: 'Edit',
		UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: '搜索',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
		DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
		StarRatings: 'Star Ratings',
		Autocomplete: 'Autocomplete',
		Tree: 'Tree',
		// "Import/Export": 'Import/Export',
		Import: 'Import',
		Export: 'Export',
		ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	en: {
		Currencys: '73.Currency',
		Locations2: '72.Location',
		Projects: '71.Project',
		ProductsGrade: '23.Product Grade',
		ChartOfAccount: 'Chart Of Account',
		Selected: 'Select',
		Notfound: 'Not Found',
		Inputs: 'Input',
		Prints: 'Print',
		Fields: 'Field',
		Titles: 'Title',
		columns: 'Column',
		payments_types: 'Payment Type',
		ReceiveDate: 'Receive Date',
		SettingForms: 'B.Form Setting',
		SettingFormsBuy: '1.Form Setting BUY',
		SettingFormsSell: '2.FormSetting Sell',
		Qtyunits: '20.Unit Type',
		Paymenttypes: '70.Payment Type',
		Transmode: '41.Mode of Transport',
		WhtMode: '55.With holding tax Mode',
		Deposit: '1.Deposit',
		deposit: '1.Deposit',
		Titlepos: 'Name prefix',
		Costs: 'Cost',
		Returns: 'Return',
		Cumulative: 'Cumulative',
		Debits: 'Debit',
		Credits: "Credit",
		Depreciation: 'Depreciation',
		Assets: 'Asset',
		Cheque: 'Cheque',
		Deadline: 'Deadline',
		Remarks: 'Remark',
		Generals: 'General',
		Changed: 'Change',
		Banks: 'Bank',
		Formats: 'Format',
		Decimals: 'Decimal',
		Multiplys: 'Multiply',
		Periods: 'Period',
		Show: 'Show',
		Hide: 'Hide',
		Save: 'Save',
		Phone: 'Phone',
		English: 'English',
		Chinese: 'Chinese',
		Thai: 'Thai',
		Company: "Company",
		CompanysTypes: 'Company Type',
		SettingStarts: '1.Setting Start',
		SettingTables: '2.Setting Database',
		SettingFinrounds: '3.Setting Finance Round',
		SettingDocuments: '4.Setting Document',
		SettingFincons: '5.Setting Finance Connect',
		SettingDepts: '6.Setting Department',
		SettingNewcoms: '7.Setting New Company',
		SettingMessages: '8.Setting Message',
		SettingMessagesGeneral: '1.General',
		SettingMessagesVendor: '2.Vendor',
		SettingMessagesCustomer: '3.Customer',
		SettingMessagesBank: '4.Bank',
		SettingMessagesVat: '5.VAT',
		SettingMessagesProduct: '6.Product',
		SettingMessagesFinance: '7.Finance',
		SettingStartsCompany: '1.Company Detail',
		SettingStartsGeneral: '2.General',
		SettingStartsStockRemains: '3.Stock Remain',
		SettingStockRemains: '2.Product Group',
		SettingStartsSellandCustomer: '4.Sell and Customer',
		SettingStartVendorMethod: '2.Payment Method',
		SettingStartsBuyandSuppliers: '5.Buy and Vendor',
		SettingStartsBanks: '6.Banking',
		SettingStartsFin: '7.Finance',
		SettingStartsAssets: '8.Asset',
		SettingAssets: '2.Group Asset',
		GeneralsDetails: '1.General',
		SettingStartsBanksDetail: 'Bank Detail',
		SettingStartsBanksName: 'Bank Name',
		Account: 'Account',
		Values: 'Values',
		WHT: 'WITHOLDING TAX',
		percent: 'Percent',
		Vats: 'VAT',
		Ports: 'Port',
		Countrys: 'Country',
		Terms: 'Term',
		Agents: 'Agent',
		Modes: 'Mode',
		Modessub: 'SubMode',
		Modessubmore: 'SubMode Extention',
		Choose: 'Choose',
		Customers: 'Customer',
		CustomerDetails: 'Customer Detail',
		Supplier: 'Supplier',
		SupplierDetails: 'Supplier Detail',
		Cash: 'Cash',
		Credit: 'Credit',
		Price: 'Price',
		Details: 'Detail',
		Buy: 'Buy',
		Sell: 'Sell',
		SellOrder: '3.Sell Order',
		sellorder: '2.Sell Order',
		SellOrder2: 'Sell Order',
		SellCredits: 'Sell Credit',
		Day: 'Day',
		Month: 'Month',
		Year: 'Year',
		Balance: 'Balance',
		Decrease: 'Decrease',
		Increase: 'Increase',
		Slabsfinalstransreport: 'Slab Complete Transection Report',
		Slabstransreport: 'Slab Transection Report',
		Blockstransreport: 'Block Transection Report',
		Report: 'Report',
		BlocksCut: 'Cutting Block',
		SlabsCut: 'Cutting Slab',
		Address: 'Address',
		PO_Block: 'PO_Block',
		PO_Slab: 'PO_Slab',
		Locations: 'Location',
		Block: 'Block',
		Slab: 'Slab',
		Contacts: 'Contacts',
		FinishedGoods: 'FinishedGoods',
		Cuttings: 'Cuttings',
		RawMaterial: 'RawMaterial',
		Products: 'Products',
		ProductsDetails: 'Products Details',
		ProductsNormal: '2.Product (Stock)',
		ProductsService: '3.Product (No Stock)',
		ProductType: 'ProductType',
		List: 'List',
		Purchase: 'Purchase',
		PurchaseOrder: '3.PurchaseOrder',
		purchaseorder: 'PurchaseOrder',
		PurchaseCredit: '4.PurchaseCredit',
		purchasecredit: '3.PurchaseCredit',
		PurchaseAndOrder: 'PurchaseOrder/Order',
		Order: 'Order',
		Vendors: 'Vendors',
		Setting: 'Setting',
		MyHome: 'Home',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		FullCalendar: 'Full Calendar',
		SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		ItemDetails: 'Item Details',
		Cart: 'Cart',
		WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		CardColors: 'Card Colors',
		Table: 'Table',
		agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		User: 'User',
		View: 'View',
		Edit: 'Edit',
		UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
		DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
		StarRatings: 'Star Ratings',
		Autocomplete: 'Autocomplete',
		Tree: 'Tree',
		// "Import/Export": 'Import/Export',
		Import: 'Import',
		Export: 'Export',
		ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},

}
